import SignatureCanvasModule from "react-signature-canvas";

const SignatureCanvas = SignatureCanvasModule.default as any;

export type SignatureCanvasInstance = InstanceType<typeof SignatureCanvas>;

export default SignatureCanvas;
